
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venues/[venueId]",
      function () {
        return require("private-next-pages/venues/[venueId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venues/[venueId]"])
      });
    }
  